export const RESET_PASSWORD_EMAIL_REQUIRED_ERROR = 'Enter your username.';
export const RESET_PASSWORD_EMAIL_FORMAT_ERROR = 'Enter a valid username.';
export const RESET_PASSWORD_TITLE_LEAD = 'Reset';
export const RESET_PASSWORD_TITLE_TAIL = 'Password';

export const RESET_PASSWORD_SUBMIT_ERROR
  = 'Unable to send a reset link right now. Please try again.';
export const RESET_PASSWORD_SUBMIT_LATER_ERROR = 'Unable to send a reset link right now. Please try again later.';
export const RESET_PASSWORD_RESEND_MISSING_EMAIL_ERROR
  = 'We could not determine which email to resend. Return and submit the form again.';
export const RESET_PASSWORD_RESEND_ERROR = 'Unable to resend the reset email right now. Please try again later.';
export const RESET_PASSWORD_EMAIL_SENT_TITLE = 'Check your email';
export const RESET_PASSWORD_EMAIL_SENT_DESCRIPTION
  = 'A password reset message was sent to your email.';
export const RESET_PASSWORD_RESEND_ACTION_LABEL = 'Resend reset message';
export const RESET_PASSWORD_SUBMIT_LABEL = 'Email me a recovery link';
export const RESET_PASSWORD_EMAIL_LABEL = 'Username';
export const RESET_PASSWORD_EMAIL_PLACEHOLDER = 'johndoe@scalar.io';
